import { useEffect } from 'react';

import CrFavicon from '../../assets/images/favicon.ico';

export default function useSetFavicon(favicon) {
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = favicon || CrFavicon;
  }, [favicon]);
}
